import React from "react";
import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "../store/index";
import { hasError, doSessionLogin } from "../store/app";
import type { CommonProps } from "../common";
import type { CommonPropsWithProfile } from "./types";

function injectUserProfile(
  Component: React.ComponentType<CommonPropsWithProfile>
): React.ComponentType<CommonProps> {
  const WrappedComponent = (props: CommonProps) => {
    const dispatch = useDispatch();
    const { loading, error, profile } = useSelector(
      (state: RootState) => state.appState
    );

    const { user, signOut } = props;

    React.useEffect(() => {
      if (!user) {
        return;
      }

      (async () => {
        try {
          const token = await user.getIdToken();
          dispatch(doSessionLogin(token));
        } catch (e) {
          console.log(e);
          dispatch(hasError());
        }
      })();
    }, [dispatch, user]);

    if (loading) {
      return <p>Checking user profile</p>;
    }

    if (profile === null || error) {
      return <p>Permission Denied</p>;
    }

    return <Component user={user} signOut={signOut} profile={profile} />;
  };

  return WrappedComponent;
}

export default injectUserProfile;
